import { render, staticRenderFns } from "./LoyaltyPointScanDetailViewTagChips.vue?vue&type=template&id=4ae38ef1&scoped=true&"
import script from "./LoyaltyPointScanDetailViewTagChips.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointScanDetailViewTagChips.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointScanDetailViewTagChips.vue?vue&type=style&index=0&id=4ae38ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae38ef1",
  null
  
)

export default component.exports